import * as React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import TaxonomyTargetAudienceTeaser from './Teaser';
import TaxonomyTargetAudiencePage from './Page';
import type { TaxonomyTargetAudience } from '../../../types/uncinc_profile/taxonomy';

type TargetAudienceViewmode = 'teaser';

interface TargetAudienceProps {
  entity: ImmutableEntity<TaxonomyTargetAudience>;
  viewMode: TargetAudienceViewmode;
}

const TaxonomyTargetAudienceWrapper: React.FC<TargetAudienceProps> = ({
  entity,
  viewMode,
  ...restProps
}) => {
  switch (viewMode) {
    case 'teaser':
      return <TaxonomyTargetAudienceTeaser {...restProps} entity={entity} />;
    default:
      return <TaxonomyTargetAudiencePage {...restProps} entity={entity} />;
  }
};

export default TaxonomyTargetAudienceWrapper;
